import { format, parseISO } from "date-fns";

export const operators = [
  {value: 'between', label: 'between'},
  {value: '=', label: 'on'},
  {value: '<', label: 'before'},
  {value: '>', label: 'after'},
  {value: 'isNull', label: 'no value'},
];

export const LOOKBACK_OPERATORS = [
  { value: 'lookback:yesterday', label: 'Yesterday'          },
  { value: 'lookback:today',     label: 'Today'              },
  { value: 'lookback:1-week',    label: 'In the past week'   },
  { value: 'lookback:1-month',   label: 'In the past month'  },
  { value: 'lookback:3-month',   label: 'In the past 3 months' },
  { value: 'lookback:1-year',    label: 'In the past year'   },
];

export const relativePattern = /^([+-]?)(\d+)\s+(day|week|month)s?$/;

export function parseRelative(str) {
  const match = str.match(relativePattern);
  if (!match) return { amount: '', unit: 'day', direction: 'ago' };
  const [, sign, amount, unit] = match;
  return { amount: parseInt(amount), unit, direction: sign === '-' ? 'ago' : 'from now' };
}

export function buildRelativeString({ amount, unit, direction }) {
  const n = Number(amount);
  if (!n || n <= 0) return '';
  const sign = direction === 'ago' ? '-' : '';
  return `${sign}${n} ${unit}`;
}

const formatDate = str => format(parseISO(str), 'MM/dd/yyyy');

export function getFormattedValue(field, filter) {
  switch (filter.operator) {
    case 'lookback:yesterday': return 'Yesterday';
    case 'lookback:today':     return 'Today';
    case 'lookback:1-week':    return 'In the past week';
    case 'lookback:1-month':   return 'In the past month';
    case 'lookback:3-month':   return 'In the past 3 months';
    case 'lookback:1-year':    return 'In the past year';
    case 'relative:previous': {
      const n = Number(filter.value);
      return `Previous ${n} ${filter.valueTwo}${n !== 1 ? 's' : ''}`;
    }
    case 'relative:next': {
      const n = Number(filter.value);
      return `Next ${n} ${filter.valueTwo}${n !== 1 ? 's' : ''}`;
    }
    case 'between':
      return `${formatDate(filter.value)} – ${formatDate(filter.valueTwo)}`;
    case '<':
      return `before ${formatDate(filter.value)}`;
    case '>':
      return `after ${formatDate(filter.value)}`;
    case '=':
      return formatDate(filter.value);
    case 'isNull':
      return 'empty';
  }
}

export function isValid(filter) {
  switch (filter.operator) {
    case 'lookback:yesterday':
    case 'lookback:today':
    case 'lookback:1-week':
    case 'lookback:1-month':
    case 'lookback:3-month':
    case 'lookback:1-year':
    case 'isNull':
      return true;
    case 'relative:previous':
    case 'relative:next':
      return Number(filter.value) > 0 && !!filter.valueTwo;
    case '<':
    case '>':
    case '=':
      return filter.value.length > 0;
    case 'between':
      if (!filter.value.length || !filter.valueTwo.length) return false;
      return filter.value < filter.valueTwo;
  }
}

export function getApiParam(field, filter) {
  switch (filter.operator) {
    case 'lookback:yesterday': return 'between(yesterday 00:00:00|yesterday 23:59:59)';
    case 'lookback:today':     return 'between(today 00:00:00|today 23:59:59)';
    case 'lookback:1-week':    return 'between(-1 week 00:00:00|today 23:59:59)';
    case 'lookback:1-month':   return 'between(-1 month 00:00:00|today 23:59:59)';
    case 'lookback:3-month':   return 'between(-3 month 00:00:00|today 23:59:59)';
    case 'lookback:1-year':    return 'between(-1 year 00:00:00|today 23:59:59)';
    case 'relative:previous':
      return `between(-${filter.value} ${filter.valueTwo} 00:00:00|today 23:59:59)`;
    case 'relative:next':
      return `between(today 00:00:00|+${filter.value} ${filter.valueTwo} 23:59:59)`;
    case null:
    case '=':
      // Look for anything on that day
      return `between(${filter.value} 00:00:00|${filter.value} 23:59:59)`;
    case 'between':
      return `between(${filter.value} 00:00:00|${filter.valueTwo} 23:59:59)`;
    case '<':
      return `before(${filter.value} 00:00:00)`;
    case '>':
      return `after(${filter.value} 23:59:59)`;
    case 'isNull':
      return 'is(null)';
  }
}
